<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-13 09:23:25
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-05-26 10:41:27
-->
<template>
  <div>
    <mrc_ess_table v-if="$route.name == 'serial-number'"
                   :headers="headers"
                   :hideAddBtn="!hasBtn('add-serial-number')"
                   pageName="addSerialNumber"
                   :paginationOptions="options"
                   @turnPage="getlist"
                   :isLoading="loading"
                   :slotKey="['org_level_uuid', 'swift_config_name']"
                   :items="desserts">
      <template v-slot:search>
        <v-row class="d-flex justify-end"
               style="background: white;
          margin: 0;
          border-top-right-radius: 8px;
          border-top-left-radius: 8px;padding: 0 16px">
          <mrc_ess_advanceFilterAndSearchInput class="mt-4"
                                               v-model="systemSeniorQueryString"
                                               @success="getlist({ cpage: 1 })"
                                               :systemFieldMeta="systemFieldMeta"></mrc_ess_advanceFilterAndSearchInput>
        </v-row>
      </template>

      <template v-slot:item.swift_config_name="{ item }">
        {{ INT(item.swift_config_name) }}
      </template>

      <template v-slot:item.org_level_uuid="{ item }">
        <mrc_ess_chip class="mr-1 my-1"
                      small
                      v-for="(item1, index) in splitINT(item.org_level_uuid)"
                      :key="item1 + index">
          {{ INT(item1) }}
        </mrc_ess_chip>
      </template>

      <!-- 操作 -->
      <template v-slot:item.actions="{ item }">
        <menu-list :list="menulist"
                   @handleClick="handleClick($event, item)">
          <template v-slot:showAction>
            <v-icon v-btnAuth="[
                'view-serial-number',
                'edit-serial-number',
                'delete-serial-number',
              ]">mdi-dots-vertical</v-icon>
          </template>
        </menu-list>
      </template>
    </mrc_ess_table>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import {
  getserialNumberList,
  createSerialNumber,
  detailSerialNumber,
  addSerialNumber,
  updateSerialNumber,
  deleteSerialNumber,
} from "@/service/api/serialNumber.js"
export default {
  components: {},
  props: {},
  data () {
    return {
      systemFieldMeta: [],
      field_alias_name: null,
      table_alias_name: null,
      systemSeniorQueryString: [],
      stepIndex: 1,
      dialog: false,
      disabled: true,
      list: {},
      options: {
        pagesize: this.$store.state.pageSize, //条数
        cpage: this.$store.state.cpage, //页数
        totalcount: null, //总条数
        totalpage: null, //总页数
      },
      loading: false,
      desserts: [],
    }
  },
  computed: {
    menulist () {
      return [
        {
          name: this.$t("label_View"),
          show: this.hasBtn("view-serial-number"),
          type: "view",
        },
        {
          name: this.$t("label_Edit"),
          show: this.hasBtn("edit-serial-number"),
          type: "edit",
        },
        {
          name: this.$t("label_delete"),
          show: this.hasBtn("delete-serial-number"),
          type: "del",
        },
      ]
    },
    headers () {
      return [
        {
          text: this.$t("label_SwiftName"),
          align: "start",
          value: "swift_config_name",
          sortable: false,
        },
        // {
        //   text: this.$t("label_Preview"),
        //   value: "swift_config_preview",
        //   sortable: false,
        //   align: "start",
        // },
        {
          text: this.$t("label_company"),
          value: "org_level_uuid",
          sortable: false,
          align: "start",
        },
        {
          text: "",
          value: "actions",
          sortable: false,
          align: "end",
          width: "100",
        },
      ]
    },
  },
  beforeCreate () {
    this.$store.commit("setCpage", 1)
  },
  async created () {
    await this.getBtnPermissionList()
  },
  watch: {
    $route (v) {
      if (v.name == "serial-number") {
        this.getlist()
      }
    },
  },
  async mounted () {
    await this.getlist()
  },
  beforeDestroy () { },
  methods: {
    async getlist (obj) {
      this.loading = true
      if (
        this.desserts &&
        this.desserts.length == 1 &&
        this.options.cpage != 1 &&
        this.$route.params.type == "del"
      )
        this.options.cpage--
      if (obj) {
        const { cpage, pagesize } = obj
        this.options = { ...this.options, ...obj }
      }
      const res = await getserialNumberList({
        cpage: this.options.cpage,
        pagesize: this.options.pagesize,
        systemSeniorQueryString: this.systemSeniorQueryString,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      })
      if (res.code == 200) {
        this.desserts = res.data
        this.options.totalcount = res.totalcount
        this.options.totalpage = res.totalpage
        this.systemFieldMeta = res.systemFieldMeta
        this.field_alias_name = res.field_alias_name
        this.table_alias_name = res.table_alias_name
      }
      this.loading = false
    },
    addSerialNumber () {
      this.$store.commit("set_subPage_name", "")
      this.$store.commit("set_uuid", "")
      this.$store.commit("set_iconstatus", "") //行内进图标显示
      this.$router.push({
        name: "addSerialNumber",
      })
    },
    godetail (item) {
      this.$store.commit("set_iconstatus", true) //行内进图标显示
      this.$store.commit("set_subPage_name", item.swift_config_name)
      this.$store.commit("set_uuid", item.uuid) //
      this.$router.push({
        name: "detailSerialNumber",
      })
    },
    handleClick ({ item }, obj) {
      switch (item.type) {
        case "view":
          this.godetail(obj)
          break
        case "edit":
          this.$store.commit("set_subPage_name", obj.swift_config_name)
          this.$store.commit("set_iconstatus", false) //行内进图标显示
          this.$store.commit("set_uuid", obj.uuid) //
          this.$router.push({
            name: "detailSerialNumber",
          })
          break
        case "del":
          this.$myConfirm({
            content: this.$t("message_Confirm_the_deletion"),
          }).then((res) => {
            deleteSerialNumber({ uuid: obj.uuid }).then((res) => {
              if (res.code == 200) {
                this.$Message({
                  text: this.$t("message_The_deletion_was_successful"),
                })
                if (this.desserts.length == 1) this.options.cpage--
                this.getlist()
              }
            })
          })
          break
      }
    },
    success () { },
    cancel () { },
  },
}
</script>

<style scoped>
.cardtitle {
  position: relative;
}
.emailbtn {
  position: absolute;
  right: 70px;
  top: -50px;
}
.dowanTemplate {
  position: absolute;
  right: 180px;
  top: -50px;
}
</style>
